import { render, staticRenderFns } from "./ExcluirAprovador.vue?vue&type=template&id=38dc52ec&scoped=true"
import script from "./ExcluirAprovador.vue?vue&type=script&lang=js"
export * from "./ExcluirAprovador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc52ec",
  null
  
)

export default component.exports